function fn_comp_product_detail() {
    var $fn = $(".comp_product_detail");

    if ($fn.length) {
        $fn.on("click","[data-thumb]",function(e) {
            e.preventDefault();

            var $this = $(this),
                $gallery_data = $this.parents(".elm_images").data("gallery"),
                $index = $this.data("thumb");

            console.log($gallery_data);

            $this.lightGallery({
                dynamic: true,
                thumbnails: true,
                counter: true,
                download: true,
                closable: true,
                index: parseInt($index, 10),
                dynamicEl: $gallery_data,
                share: false,
                fullScreen: false,
                autoplay: false
            });
        });
        $(window).on("resize",fn_show_arrows);

        setTimeout(function () {
            fn_show_arrows();
        },50);

        function fn_show_arrows() {

            if ($fn.find(".elm_table").width() < $fn.find(".elm_table table").width()) {
                console.log("arrows show");
                $fn.find(".elm_arrows").show();
            } else {
                console.log("arrows hide");
                $fn.find(".elm_arrows").hide();
            }
        }

        $fn.on("click", "[data-table-left]", function(e){
            e.preventDefault();
            var $table_position = $fn.find(".elm_table").scrollLeft();
            $fn.find(".elm_table").stop(true).animate( { scrollLeft: -300+$table_position}, 300);
        });

        $fn.on("click", "[data-table-right]", function(e){
            e.preventDefault();
            var $table_position = $fn.find(".elm_table").scrollLeft();
            $fn.find(".elm_table").stop(true).animate( { scrollLeft: 300+$table_position}, 300);
        });

        var $parameters = $(".elm_parameters");

        if ($parameters.length) {

            $(".elm_parameters table").css("width","auto");

            // function fn_resize_table() {
            //     $(".col--compare table tbody tr").each(function (index) {
            //         var $height = $(this).height();
            //
            //         console.log($height);
            //
            //         $(".col--current table tbody tr:eq("+index+")").height($height);
            //     })
            // }
            // fn_resize_table();
            //
            // $(window).on("resize",function () {
            //     fn_resize_table();
            // })
        }

    }
}